// extracted by css-extract-rspack-plugin
export default {"logo":"DashboardSidebarStub_logo__HQaqY","sidebar":"DashboardSidebarStub_sidebar__4gp35"};